
const ROLE_NAMES = {
  admin:      'Administrator',
  power_user: 'Power User',
  user:       'User'
}

export function getUserFriendlyRoleName(role) {
  return ROLE_NAMES[role]
}